import Axios from "axios";
import config from "config";

const returnError = (err) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: "There is a problem",
  };
  return data;
};

export const storeCategory = async (newData, token) => {
  try {
    const url = `${config.apiserver}/catalog/createnewcategory/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const updateCategory = async (newData, token) => {
  try {
    const url = `${config.apiserver}/catalog/updatecategory/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const deleteCategory = async (newData, token) => {
  try {
    const url = `${config.apiserver}/catalog/deletecategory/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getCategory = async (newData, token) => {
  try {
    const url = `${config.apiserver}/catalog/getcategory/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getCategories = async (newDatas, token) => {
  try {
    const url = `${config.apiserver}/catalog/getcategories/`;
    const result = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};

export const storeCatalogue = async (newData, image, token) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(newData));
    formData.append("image", image);
    const url = `${config.apiserver}/catalog/createnewcatalog/`;
     const result = await Axios.post(url, formData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const updateCatalogue = async (newData, image, token) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(newData));
    formData.append("image", image);
    const url = `${config.apiserver}/catalog/updateCatalogue/`;
    const result = await Axios.post(url, formData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const deleteCatalogue = async (newData, token) => {
  try {
    const url = `${config.apiserver}/catalog/deleteCatalogue/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getCatalogue = async (newData, token) => {
  try {
    const url = `${config.apiserver}/catalog/getcatalog/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getCatalogues = async (newDatas, token) => {
  try {
    const url = `${config.apiserver}/catalog/getcataloges/`;
    const result = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
